export const DOCUMENT_STATUSES = {
  notStarted: 'NOT_STARTED',
  enqueued: 'ENQUEUED',
  succeeded: 'SUCCEEDED',
  failed: 'FAILED',
  recognizing: 'RECOGNIZING',
  indexing: 'INDEXING',
} as const
